export default __webpack_public_path__ + "510b79abcc59f98305cd423a4b802032.png";